import React__default from 'react';
import { useUID, createStormTaktId, InlineMessage, Button, Tooltip } from '@amzn/storm-ui';
import { b as Footer, c as FooterSuccessContainer, R as ResubmitButton, E as ErrorMessageWrapper, d as FooterButtonsContainer, e as CancelButton, f as DisabledSubmitButton } from './FormLayout.styles-BzYy_4z2.js';
import { u as useFormStage } from './hooks/useStage-C5gC2haD.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const DisabledButton = ({
  formId,
  submitButtonLabel,
  validationErrorMessage,
  disableSubmitButtonTooltip
}) => {
  if (disableSubmitButtonTooltip) {
    return /*#__PURE__*/React__default.createElement(DisabledSubmitButton, {
      "aria-disabled": "true",
      form: formId,
      type: "submit"
    }, submitButtonLabel);
  }
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    trigger: /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DisabledSubmitButton, {
      "aria-disabled": "true",
      form: formId,
      type: "submit"
    }, submitButtonLabel)),
    message: validationErrorMessage,
    withCloseButton: false,
    type: "dark"
  });
};
const FormLayoutFooter = ({
  cancelButtonLabel = 'Cancel',
  disableSubmitButtonTooltip = false,
  formId,
  isMobile,
  isSubmitting,
  onClickResubmit = noop,
  onClose = noop,
  renderError,
  resubmitButtonLabel = 'Submit more feedback',
  resubmitEnabled = true,
  submitButtonLabel = 'Submit',
  submitEnabled,
  submitErrorMessage,
  submittingButtonLabel = 'Submitting...',
  validationErrorMessage,
  taktId
}) => {
  const cancelButtonUid = useUID('footer-cancel-button');
  const resubmitButtonUid = useUID('footer-resubmit-button');
  const {
    stage
  } = useFormStage();
  const isSubmittedStage = stage === 'submitted';
  if (isSubmittedStage) {
    if (resubmitEnabled) {
      return /*#__PURE__*/React__default.createElement(Footer, {
        $isMobile: isMobile,
        $isSubmittedStage: isSubmittedStage
      }, /*#__PURE__*/React__default.createElement(FooterSuccessContainer, null, /*#__PURE__*/React__default.createElement(ResubmitButton, {
        id: resubmitButtonUid,
        onClick: event => {
          onClickResubmit(event);
        },
        taktId: createStormTaktId('resubmit-button')
      }, resubmitButtonLabel)));
    }
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Footer, {
    $isMobile: isMobile,
    $isSubmittedStage: isSubmittedStage
  }, !!submitErrorMessage && /*#__PURE__*/React__default.createElement(ErrorMessageWrapper, null, typeof renderError === 'function' ? renderError(submitErrorMessage) : /*#__PURE__*/React__default.createElement(InlineMessage, {
    messageType: "error",
    message: renderError !== null && renderError !== void 0 ? renderError : submitErrorMessage
  })), /*#__PURE__*/React__default.createElement(FooterButtonsContainer, null, submitEnabled ? /*#__PURE__*/React__default.createElement(Button, {
    form: formId,
    type: "submit",
    primary: true,
    loading: isSubmitting,
    taktId: createStormTaktId('submit-button')
  }, isSubmitting ? submittingButtonLabel : submitButtonLabel) : /*#__PURE__*/React__default.createElement(DisabledButton, {
    formId: formId,
    submitButtonLabel: submitButtonLabel,
    validationErrorMessage: validationErrorMessage,
    disableSubmitButtonTooltip: disableSubmitButtonTooltip
  }), /*#__PURE__*/React__default.createElement(CancelButton, {
    id: cancelButtonUid,
    onClick: onClose,
    taktId: createStormTaktId('cancel-button')
  }, cancelButtonLabel)));
};

export { FormLayoutFooter as F };
//# sourceMappingURL=FormLayoutFooter-DdsU8_Q_.js.map
